module.exports = {
      id: "season-all-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#season-all",
      toString: function () {
        return this.url;
      }
    }